export class StickyHeaderComponent {
  container;

  scrollChange = 1;
  scrollPos = window.scrollY;

  constructor() {
    this.container = document.querySelector('.header-row');
  }

  initialize() {
    if (!this.container) {
      return;
    }

    this.toggleSticky();
    this.addEventListeners();
  }

  addEventListeners() {
    window.addEventListener('scroll', (e) => this.windowScrollHandler(e));
  }

  windowScrollHandler(e) {
    this.scrollPos = window.scrollY;
    this.toggleSticky();
  }

  toggleSticky() {
    this.scrollPos >= this.scrollChange ? this.container.classList.add('sticky') : this.container.classList.remove('sticky');
  }
}